// Mirrors the backend support app (apps/support: models.py + files.py). Keep
// the limits in step with support/files.py — the server re-checks every one of
// them, these only spare the user a round-trip.

export const SUPPORT_STATUS = {
  OPEN: "open",
  ANSWERED: "answered",
  CLOSED: "closed",
};

export const SUPPORT_CATEGORIES = ["question", "bug", "access", "suggestion", "other"];

export const SUPPORT_SENDER = {
  USER: "user",
  AGENT: "agent",
  SYSTEM: "system",
};

export const SUPPORT_SUBJECT_MAX = 150;
export const SUPPORT_BODY_MAX = 5000;
// The name an agent shows users (SupportAgent.display_name).
export const SUPPORT_AGENT_NAME_MAX = 128;

export const SUPPORT_MAX_FILES = 5;
export const SUPPORT_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const SUPPORT_FILE_EXTENSIONS = [
  ".png", ".jpg", ".jpeg", ".webp", ".gif",
  ".pdf", ".txt", ".csv", ".xlsx", ".docx",
];
export const SUPPORT_FILE_ACCEPT = SUPPORT_FILE_EXTENSIONS.join(",");

// status -> i18n key + pill classes. One table, read by every surface that
// shows a status (site list, thread header, Mini App).
export const SUPPORT_STATUS_META = {
  [SUPPORT_STATUS.OPEN]: {
    labelKey: "support.status.open",
    badge: "bg-amber-50 text-amber-700 border-amber-200",
  },
  [SUPPORT_STATUS.ANSWERED]: {
    labelKey: "support.status.answered",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
  },
  [SUPPORT_STATUS.CLOSED]: {
    labelKey: "support.status.closed",
    badge: "bg-slate-100 text-slate-500 border-slate-200",
  },
};
